// SC-3517 — the table's `?row=<_id>` param: the entity drawer opened by the row's
// Mongo `_id` (History's "Open product"), kept in the URL so a reload or a shared
// link reopens the same product. TableTab mirrors it both ways with the workspace
// store's FE-only row overlay.

export const ROW_PARAM = 'row';

/** The table's query string (no leading `?`) for the drawer open on `rowId`. */
export function rowSearch(rowId: string): string {
  return new URLSearchParams({ [ROW_PARAM]: rowId }).toString();
}

/** The open row's id from the table URL, or `null`. A blank value is no row. */
export function parseRowParam(search: URLSearchParams): string | null {
  const id = search.get(ROW_PARAM)?.trim();
  return id ? id : null;
}
